import { ADT } from "pb.adt";

import type { RefundTransactionState } from "./refund-transaction";
import type { SelectTransactionState } from "./select-transaction";

export const Page = ADT.define(
	{} as {
		Initialising: true;
		/** Sent to the terminal, awaiting its acknowledge. */
		InitialisingRefund: true;
		// transaction states
		AwaitTransaction: true;
		AwaitProcessing: {
			isoProcessingCode: string;
			refundAmount: number;
			transactionUuid: string;
		};
		AwaitAccountSelection: { onClose: () => void; cancelling?: boolean };
		AwaitApplicationSelection: { onClose: () => void; cancelling?: boolean };
		AwaitPaymentMethod: { onClose: () => void; cancelling?: boolean };
		AwaitPinEntry: { onClose: () => void; cancelling?: boolean };
		AwaitSignature: { onClose: () => void; cancelling?: boolean };
		DisplayPaymentMessage: { onClose: () => void; cancelling?: boolean };
		RefundTransaction: RefundTransactionState;
		SelectTransaction: SelectTransactionState;
		SignatureSubmitted: {
			signature?: string;
			onClose: () => void;
			onApprove: () => void;
			onDecline: () => void;
			cancelling?: boolean;
		}; // response states
		Approved: {
			currency?: string;
			totalCents: number;
			onDone: () => void;
		};
		Declined: {
			title: string;
			subtitle?: string;
			message?: string;
			onRetry: () => void;
			onCancel: () => void;
		};
		Cancelled: { onClose: () => void };
		ErrorDisconnected: { onClose: () => void; onRetry: () => void };
		ErrorInactivityTimeout: { onClose: () => void; onRetry: () => void };
		ErrorOperation: { onClose: () => void; onRetry?: () => void };
		ErrorNetwork: { onClose: () => void; onRetry: () => void };
		ErrorTerminalBusy: { onClose: () => void; onRetry: () => void };
		ErrorTerminalUnreachable: { onClose: () => void; onRetry: () => void };
		ErrorTerminalMissing: { onClose: () => void };
		ErrorTransactionNotFound: { onClose: () => void };
	},
);

export type Page = ADT.define<typeof Page>;
